import React, { FC, useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import {
  AppState,
  Auth0Provider as Auth0ProviderComponent,
} from '@auth0/auth0-react'

import { env } from 'common/config/env'

const Auth0Provider: FC<{ children?: React.ReactNode }> = ({ children }) => {
  const history = useHistory()

  const audience = env.auth0Audience
  const clientId = env.auth0ClientId
  const domain = env.auth0Domain

  const onRedirectCallback = useCallback(
    (appState?: AppState): void => {
      history.push(appState?.returnTo || `${window.location.pathname}`)
    },
    [history]
  )

  const getRedirectUri = () => {
    const url = window.location.href
    const origin = window.location.origin

    if (url.includes('error=access_denied')) {
      if (url.includes('error_description=RESET_PASSWORD')) {
        return `${origin}/expired-password`
      }
      return `${origin}/logout-sso`
    }

    return origin
  }

  return (
    <Auth0ProviderComponent
      clientId={clientId}
      domain={domain}
      authorizationParams={{
        redirect_uri: getRedirectUri(),
        audience,
      }}
      onRedirectCallback={onRedirectCallback}
      cacheLocation={import.meta.env.DEV ? 'localstorage' : 'memory'}
      useRefreshTokens={true}
      useRefreshTokensFallback={true}
    >
      {children}
    </Auth0ProviderComponent>
  )
}

export default Auth0Provider
